<div class="search-bar-container">
  <div class="search-left-group">
    <div class="fs-field">
      <span class="fs-label">Search By</span>
      <select
        *ngIf="searchFieldDropdownVisible"
        class="native-select"
        aria-label="Search by field"
        (change)="onSearchFieldChange($any($event.target).value)"
      >
        <option value="" disabled [selected]="!selectedSearchField">Select field</option>
        <option *ngFor="let o of searchFieldOptions" [value]="o.value" [selected]="selectedSearchField === o.value">{{ o.label }}</option>
      </select>
    </div>
    <div class="op-search">
      <i class="material-icons op-search-ic">search</i>
      <input
        type="text"
        [ngModel]="filterValue"
        (ngModelChange)="onSearchValueChange($event)"
        [placeholder]="selectedSearchField ? 'Search…' : 'Select a field first'"
        [disabled]="!selectedSearchField"
        autocomplete="off"
        aria-label="Search candidates"
      />
      <button *ngIf="filterValue" class="op-search-clear" (click)="clearInput()" aria-label="Clear search">✕</button>
    </div>
  </div>
  <div class="search-right-group">
    <app-candidate-filter
      [fieldsVisibility]="fieldsVisibility"
      [candidatesData]="rowData"
      (candidateOutput)="handleDataFromChild($event)">
    </app-candidate-filter>
    <button class="dl-btn" [disabled]="!canDownload || isFetchingAll" (click)="download()">
      <i class="material-icons">download</i>{{ isFetchingAll ? 'Fetching…' : 'Download' }}
    </button>
  </div>
</div>
<div class="candidate-table">
  <ng-container *ngIf="pagedCandidatesData?.length; else noDataTemplate">
    <div class="op-table-wrap">
      <table class="op-table cand-table">
        <thead>
          <tr>
            <th class="c col-select">
              <input
                type="checkbox"
                class="row-check"
                aria-label="Select all matching candidates"
                [checked]="headerChecked"
                (change)="toggleAllPage($any($event.target).checked)"
              />
            </th>
            <th class="sortable" (click)="sortBy('candidateName')">Name <span class="op-sort" [class.asc]="sortField === 'candidateName' && sortDir === 'asc'" [class.desc]="sortField === 'candidateName' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('jobTitle')">Position <span class="op-sort" [class.asc]="sortField === 'jobTitle' && sortDir === 'asc'" [class.desc]="sortField === 'jobTitle' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('hiringRequestId')">Position ID <span class="op-sort" [class.asc]="sortField === 'hiringRequestId' && sortDir === 'asc'" [class.desc]="sortField === 'hiringRequestId' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('status')">Status <span class="op-sort" [class.asc]="sortField === 'status' && sortDir === 'asc'" [class.desc]="sortField === 'status' && sortDir === 'desc'"></span></th>
            <th class="c">Review</th>
            <th class="c">Initial Screening Feedback</th>
            <th class="c">Resume</th>
            <th class="sortable" (click)="sortBy('vendorName')">Vendor <span class="op-sort" [class.asc]="sortField === 'vendorName' && sortDir === 'asc'" [class.desc]="sortField === 'vendorName' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('createdDate')">Received On <span class="op-sort" [class.asc]="sortField === 'createdDate' && sortDir === 'asc'" [class.desc]="sortField === 'createdDate' && sortDir === 'desc'"></span></th>
            <th class="sortable c" (click)="sortBy('agingDays')">Profile Aging <span class="op-sort" [class.asc]="sortField === 'agingDays' && sortDir === 'asc'" [class.desc]="sortField === 'agingDays' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('earliestAvailability')">Available By <span class="op-sort" [class.asc]="sortField === 'earliestAvailability' && sortDir === 'asc'" [class.desc]="sortField === 'earliestAvailability' && sortDir === 'desc'"></span></th>
            <th class="sortable c" (click)="sortBy('yearsOfExperience')">Exp <span class="op-sort" [class.asc]="sortField === 'yearsOfExperience' && sortDir === 'asc'" [class.desc]="sortField === 'yearsOfExperience' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('hiringManagerName')">Hiring Manager <span class="op-sort" [class.asc]="sortField === 'hiringManagerName' && sortDir === 'asc'" [class.desc]="sortField === 'hiringManagerName' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('location')">Location <span class="op-sort" [class.asc]="sortField === 'location' && sortDir === 'asc'" [class.desc]="sortField === 'location' && sortDir === 'desc'"></span></th>
            <th class="sortable" (click)="sortBy('emailId')">Email <span class="op-sort" [class.asc]="sortField === 'emailId' && sortDir === 'asc'" [class.desc]="sortField === 'emailId' && sortDir === 'desc'"></span></th>
            <th>History</th>
            <th>Links</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of displayRows">
            <td class="c col-select">
              <input
                type="checkbox"
                class="row-check"
                [attr.aria-label]="'Select ' + v.candidateName"
                [checked]="isSelected(v)"
                (change)="toggleRow(v, $any($event.target).checked)"
              />
            </td>
            <td [attr.title]="v.candidateName || null">{{ v.candidateName || '—' }}</td>
            <td [attr.title]="v.jobTitle || null">{{ v.jobTitle || '—' }}</td>
            <td class="mono">{{ v.hiringRequestId || '—' }}</td>
            <td [attr.title]="v.status || null">{{ v.status || '—' }}</td>
            <td class="op-cell-actions c">
              <app-candidate-feedback
                (sendFeedbackStatus)="receiveData($event, v.emailId)"
                [fieldsVisibility]="fieldsVisibility"
                [candidateId]="v.candidateId"
                *ngIf="fieldsVisibility && v.emailId">
              </app-candidate-feedback>
            </td>
            <td class="c">
              <button *ngIf="$any(v).additionalDocumentsPath" class="ts-iconbtn" title="Download screening feedback"
                (click)="downloadFile($any(v).additionalDocumentsPath, v.candidateName, 'attachments')"><i class="material-icons">download</i></button>
            </td>
            <td class="c">
              <button *ngIf="v.resumePath" class="ts-iconbtn" title="Download resume"
                (click)="downloadFile(v.resumePath, v.candidateName, 'resume')"><i class="material-icons">download</i></button>
            </td>
            <td [attr.title]="v.vendorName || null">{{ v.vendorName || '—' }}</td>
            <td>{{ v.createdDate | date: dateFormat.Month }}</td>
            <td class="c mono">{{ v.agingDays ?? '—' }}</td>
            <td>{{ v.earliestAvailability | date: dateFormat.Month }}</td>
            <td class="c mono">{{ v.yearsOfExperience ?? '—' }}</td>
            <td [attr.title]="v.hiringManagerName || null">{{ v.hiringManagerName || '—' }}</td>
            <td [attr.title]="v.location || null">{{ v.location || '—' }}</td>
            <td [attr.title]="v.emailId || null">{{ v.emailId || '—' }}</td>
            <td class="op-cell-actions">
              <button class="ts-btn" (click)="viewHistory(v)"><i class="material-icons">history</i>History</button>
            </td>
            <td>
              <a *ngIf="v.url" class="op-jt" [href]="v.url | addHttps" target="_blank" [attr.title]="v.url">{{
                v.url.length > urlDisplayLimit ? v.url.substring(0, urlDisplayLimit) + '…' : v.url
              }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="op-tfoot">
      <div class="op-info">
        Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ totalRecords }}</b> candidates<ng-container *ngIf="selectedRows.length"> · <b>{{ selectedRows.length }}</b> selected</ng-container><ng-container *ngIf="headerChecked"> · all matching selected</ng-container>
      </div>
      <div class="op-pager">
        <button class="pg" (click)="prevPage()" [disabled]="currentPage === 1" aria-label="Previous page">‹</button>
        <button
          *ngFor="let pnum of pageWindow; trackBy: trackByIndex"
          class="pg"
          [class.on]="pnum === currentPage"
          [disabled]="pnum === -1"
          (click)="goToPage(pnum)"
        >{{ pnum === -1 ? '…' : pnum }}</button>
        <button class="pg" (click)="nextPage()" [disabled]="currentPage >= totalPages" aria-label="Next page">›</button>
      </div>
      <div class="op-psize">
        <span>Rows</span>
        <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Rows per page">
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="20">20</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
        </select>
      </div>
    </div>
  </ng-container>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="isDataLoaded && pagedCandidatesData?.length === 0">
          <h2 class="empty-state-title">No Records Found</h2>
        </ng-container>
        <img [src]="imageSrc" alt="No records illustration" class="empty-state-image" />
      </div>
    </section>
  </ng-template>

  <ng-template #historyDialog>
    <div class="status-change-dialog">
      <div class="dialog-content">
        <div *ngIf="historySubmissions?.length; else noHistory">
          <div class="duplicate-list">
            <div class="duplicate-row header">
              <div>Job ID</div>
              <div title="Job Title">Job Title</div>
              <div title="Hiring Manager">Hiring Manager</div>
              <div title="Status">Status</div>
              <div title="Feedback">Feedback</div>
              <div title="Vendor">Vendor</div>
              <div title="Submitted Date">Submitted</div>
            </div>
            <div class="duplicate-row" *ngFor="let historySubmission of historySubmissions">
              <div>{{ historySubmission.jobId }}</div>
              <div [title]="getTooltipText(historySubmission.jobTitle)">
                {{ truncateText(historySubmission.jobTitle, 20) }}
              </div>
              <div [title]="getTooltipText(historySubmission.hiringManager || '')">
                {{ truncateText(historySubmission.hiringManager || '', 20) }}
              </div>
              <div [title]="getTooltipText(historySubmission.status || '')">
                {{ truncateText(historySubmission.status || '', 15) }}
              </div>
              <div [title]="getTooltipText(historySubmission.feedback || '')">
                {{ truncateText(historySubmission.feedback || '', 30) }}
              </div>
              <div [title]="getTooltipText(historySubmission.vendorName || '')">
                {{ truncateText(historySubmission.vendorName || '', 20) }}
              </div>
              <div [title]="getTooltipText((historySubmission.submittedDate | date: 'medium') || '')">
                {{ truncateText((historySubmission.submittedDate | date: 'medium') || '', 20) }}
              </div>
            </div>
          </div>
        </div>
        <ng-template #noHistory>
          <div class="no-history">No Data Available</div>
        </ng-template>
      </div>
      <div class="dialog-actions">
        <emerald-button [label]="'Close'" [type]="'Secondary'" (onClick)="closeHistoryDialog()">
        </emerald-button>
      </div>
    </div>
  </ng-template>
</div>